"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_WORKSPACE_CONTENT_QUICK_ACCESS_PATH = exports.EVENT_DOCCENTER_CONTENT_QUICK_ACCESS_PATH = exports.EVENT_CONTENT = exports.EVENT_DATA = exports.EVENT_SYSTEM_TYPE = exports.EVENT_CONTENT_TYPE = exports.EVENT_PRODUCT_AREA = exports.EVENT_REPOSITORY = exports.EVENT_LOCALE_TYPE = exports.EVENT_DEVICE_TYPE = exports.EVENT_BROWSER = exports.EVENT_OPERATING_SYSTEM = exports.EVENT_VERSIONS = exports.EVENT_TYPES = void 0;
var EVENT_TYPES = {
    ContentView: 'content-view',
    ContentDownload: 'content-download',
};
exports.EVENT_TYPES = EVENT_TYPES;
var EVENT_VERSIONS = {
    ContentViewV2: 'content-view-v2',
    ContentDownloadV2: 'content-download-v2',
};
exports.EVENT_VERSIONS = EVENT_VERSIONS;
var EVENT_REPOSITORY = {
    library: 'library',
    doccenter: 'doccenter',
    newscenter: 'newscenter',
    workspace: 'workspace',
    generatedlivedocs: 'generatedlivedocs',
    presentationbuilder: 'presentationbuilder',
};
exports.EVENT_REPOSITORY = EVENT_REPOSITORY;
var EVENT_OPERATING_SYSTEM = {
    android: 'android',
    ios: 'ios',
    linux: 'linux',
    osx: 'osx',
    windows: 'windows',
    unknown: 'unknown',
};
exports.EVENT_OPERATING_SYSTEM = EVENT_OPERATING_SYSTEM;
var EVENT_BROWSER = {
    chrome: 'chrome',
    firefox: 'firefox',
    IE: 'internet explorer',
    edge: 'edge',
    safari: 'safari',
    ios: 'ios',
    android: 'android',
    windows: 'windows',
    unknown: 'unknown',
};
exports.EVENT_BROWSER = EVENT_BROWSER;
var EVENT_PRODUCT_AREA = {
    admin: 'admin',
    contentmanager: 'contentmanager',
    doccenter: 'doccenter',
    documentcart: 'documentcart',
    homepage: 'homepage',
    liveinsights: 'liveinsights',
    livesend: 'livesend',
    livesendviewer: 'livesendviewer',
    meetingspace: 'meetingspace',
    newscenter: 'newscenter',
    predictive: 'predictive',
    profilebuilder: 'profilebuilder',
    search: 'search',
    workspace: 'workspace',
    unknown: 'unknown',
};
exports.EVENT_PRODUCT_AREA = EVENT_PRODUCT_AREA;
var EVENT_DEVICE_TYPE = {
    pc: 'pc',
    tablet: 'tablet',
    phone: 'phone',
    unknown: 'unknown',
};
exports.EVENT_DEVICE_TYPE = EVENT_DEVICE_TYPE;
var EVENT_CONTENT_TYPE = {
    folder: 'folder',
    file: 'file',
    url: 'url',
    article: 'article',
    livedoc: 'livedoc',
    datasource: 'datasource',
    livedoccomponent: 'livedoc-component',
    livedocguidedassembly: 'livedoc-guidedassembly',
    emailtemplate: 'email-template',
    emailtemplatecomponent: 'email-template-component',
    unknown: 'unknown',
};
exports.EVENT_CONTENT_TYPE = EVENT_CONTENT_TYPE;
var EVENT_LOCALE_TYPE = {
    'de-DE': 'de-DE',
    'en-GB': 'en-GB',
    'en-US': 'en-US',
    'es-ES': 'es-ES',
    'fr-CA': 'fr-CA',
    'fr-FR': 'fr-FR',
    'it-IT': 'it-IT',
    'ja-JP': 'ja-JP',
    'ko-KR': 'ko-KR',
    'pt-BR': 'pt-BR',
    'zh-CN': 'zh-CN',
    'zh-TW': 'zh-TW',
};
exports.EVENT_LOCALE_TYPE = EVENT_LOCALE_TYPE;
var EVENT_SYSTEM_TYPE = {
    salesforce: 'salesforce',
    dynamics: 'dynamics',
    sugar: 'sugar',
    outlook: 'outlook',
    gmail: 'gmail',
    custom: 'custom*',
};
exports.EVENT_SYSTEM_TYPE = EVENT_SYSTEM_TYPE;
var EVENT_DATA = {
    'CONTENT-VIEW-V2': 'EVENT_CONTENT_VIEW_V2',
    'CONTENT-DOWNLOAD-V2': 'EVENT_CONTENT_DOWNLOAD_V2',
};
exports.EVENT_DATA = EVENT_DATA;
var EVENT_CONTENT = {
    'DOCCENTER-CONTENT': 'EVENT_DOCCENTER_CONTENT',
    'DOCCENTER-FOLDER': 'EVENT_DOCCENTER_FOLDER',
    'NEWSCENTER-CONTENT': 'EVENT_NEWSCENTER_CONTENT',
    'LIBRARY-CONTENT': 'EVENT_LIBRARY_CONTENT',
    'LIBRARY-FOLDER': 'EVENT_LIBRARY_FOLDER',
    'WORKSPACE-CONTENT': 'EVENT_WORKSPACE_CONTENT',
    'WORKSPACE-FOLDER': 'EVENT_WORKSPACE_FOLDER',
};
exports.EVENT_CONTENT = EVENT_CONTENT;
var EVENT_DOCCENTER_CONTENT_QUICK_ACCESS_PATH = {
    recents: 'recents',
    favorites: 'favorites',
};
exports.EVENT_DOCCENTER_CONTENT_QUICK_ACCESS_PATH = EVENT_DOCCENTER_CONTENT_QUICK_ACCESS_PATH;
var EVENT_WORKSPACE_CONTENT_QUICK_ACCESS_PATH = {
    recents: 'recents',
};
exports.EVENT_WORKSPACE_CONTENT_QUICK_ACCESS_PATH = EVENT_WORKSPACE_CONTENT_QUICK_ACCESS_PATH;
exports.default = {};
//# sourceMappingURL=EventEnums.js.map